import { render, staticRenderFns } from "./VerticalNavMenuSectionTitle.vue?vue&type=template&id=f9526096&scoped=true&"
import script from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuSectionTitle.vue?vue&type=style&index=0&id=f9526096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9526096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VSubheader})
